import _startsWith from "lodash/startsWith";
import _includes from "lodash/includes";
import _ from "lodash";

class Tools {
    static formatDate(date) {
        const options = {
            timeZone: `UTC`,
            hour12: false
        };

        return date && new Date(date).toLocaleString(`en-US`, options);
    }

    static booleanToString(bool) {
        return bool ? `Yes` : `No`;
    }

    static substringCountryCode(culture) {
        return culture && culture.substr(3, 2);
    }

    static getOriginDescription(origin) {
        const upperCaseOrigin = origin && origin.toUpperCase();
        if (upperCaseOrigin === `MT-EHUB`) {
            return `Automatic process through EHUB`;
        } else if (upperCaseOrigin === `CUSTOMER`) {
            return `Customer`;
        } else if (_includes(upperCaseOrigin, `NMSC`)) {
            return `Local NMSC integration`;
        } else if (_startsWith(upperCaseOrigin, `TME-TD-`)) {
            return `TechDoc`;
        } else {
            return undefined;
        }
    }

    static queryObjectToString(params) {
        let paramString = ``;

        if (params) {
            _.forEach(params, function (val, key) {
                if (typeof val !== `undefined` && val !== null) {
                    paramString += (paramString.length === 0 ? `?` : `&`) + key + `=` + val;
                }
            });
        }

        return paramString;
    }

    static queryStringToObject(params) {
        let paramObj = {};

        if (params && params.length) {
            let keyValueStrings = params.replace(`?`, ``).split(`&`);

            keyValueStrings.forEach(function (keyValueStr) {
                let keyValue = keyValueStr.split(`=`);
                if (keyValue.length === 2) {
                    paramObj[keyValue[0]] = keyValue[1];
                }
            });
        }

        return paramObj;
    }

    static orderToLabel(orderTrackerStatus) {
        const statusToCardStatus = {
            nostatus: `processedOrder`,
            processingorder: `processedOrder`,
            buildinprogress: `buildInProgress`,
            leftthefactory: `leftTheFactory`,
            leftthedepot: `inTransit`,
            arrivedincountry: `inTransit`,
            arrivedinconversioncentre: `inTransit`,
            arrivedindestination: `arrivedAtRetailer`
        };

        const statusToLabelMapping = {
            arrivedAtRetailer: `Arrived At Retailer`,
            buildInProgress: `Build In Progress`,
            inTransit: `In Transit`,
            leftTheFactory: `Left the Factory`,
            processedOrder: `Processing Order`
        };
        return statusToLabelMapping[statusToCardStatus[orderTrackerStatus && orderTrackerStatus.toLowerCase()]];
    }

    static includesOneOf(array, array2) {
        let included = false;

        if (!array || !array2) {
            return included;
        }

        array.forEach((item) => {
            if (array2.includes(item)) {
                included = true;
            }
        });

        return included;
    }
}

export default Tools;
